
import React, { memo } from "react";
import NetworkErrorAlert from "./chat/NetworkErrorAlert";
import MessageList from "./chat/MessageList";
import ChatInput from "./chat/ChatInput";
import { useAssistantChat } from "./chat/useAssistantChat";

const AssistantChat: React.FC = () => {
  const {
    input,
    setInput,
    messages,
    isLoading,
    networkError,
    retryAttempt,
    handleSendMessage,
    handleRetry,
    handleFeedbackSubmit
  } = useAssistantChat();

  return (
    <>
      <NetworkErrorAlert isVisible={networkError} />
      <MessageList 
        messages={messages} 
        isLoading={isLoading} 
        onFeedbackSubmit={handleFeedbackSubmit}
      />
      <ChatInput 
        input={input}
        setInput={setInput}
        handleSendMessage={handleSendMessage}
        handleRetry={handleRetry}
        isLoading={isLoading}
        networkError={networkError}
        retryAttempt={retryAttempt}
        hasLastMessage={!!retryAttempt}
      />
    </>
  );
};

export default memo(AssistantChat);
